import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    items: [],
    loaded: false,
    loading: false,
    error: null,
};
const areasSlice = createSlice({
    name: 'areas',
    initialState,
    reducers: {
        setAreasLoading: (state, action) => {
            state.loading = action.payload;
        },
        storeAllAreas: (_state, action) => ({
            items: action.payload,
            loaded: true,
            loading: false,
            error: null,
        }),
        storeOneArea: (state, action) => {
            const existingIndex = state.items.findIndex((area) => area.id === action.payload.id);
            if (existingIndex >= 0) {
                return Object.assign(Object.assign({}, state), { items: state.items.map((item, index) => (index === existingIndex ? action.payload : item)) });
            }
            return Object.assign(Object.assign({}, state), { items: [...state.items, action.payload] });
        },
        setAreasError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearAreasError: (state) => {
            state.error = null;
        },
    },
});
export const { setAreasLoading, storeAllAreas, storeOneArea, setAreasError, clearAreasError, } = areasSlice.actions;
export default areasSlice.reducer;
